import DsSelect from './DsSelect'

export default Vue => {
  Vue.component(DsSelect.name, DsSelect)
}



// WEBPACK FOOTER //
// ./src/components/dsselect/index.js